// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__+lmHn","location":"LocationSection_location__JvH5i"};